import { toParamString } from "../utils/UrlUtility";
import { doFetch } from "./apiFetchHelper";

export const getStore = (params) => {
  const { storeKey } = params;
  const { lat, lon } = params.currentLocation;

  const applyDistanceParams = () => {
    return lat && lon;
  };

  const paramsObj = {};

  if (applyDistanceParams()) {
    paramsObj.lat = lat;
    paramsObj.lon = lon;
  }

  const paramsString = `${toParamString(paramsObj)}`;

  const url = `/api/store/${storeKey}${paramsString ? "?" + paramsString : ""}`;

  return doFetch(url);
};

export const getOffer = (params) => {
  const { offerKey } = params;

  const url = `/api/store/offers/${offerKey}`;

  return doFetch(url);
};

export const checkStoreAvailability = (storeKeys) => {
  const url = `/api/store/availability?store_keys=${storeKeys}`;
  return doFetch(url);
};

export const checkOfferAvailability = (offerKeys) => {
  const url = `/api/store/offer/availability?offer_keys=${offerKeys}`;
  return doFetch(url);
};
